const RADE_ADMIN_SALVED_KEEP_ME_SIGNED_IN_COOKIE_KEY =
  '@rade-admin:authentication';

export { RADE_ADMIN_SALVED_KEEP_ME_SIGNED_IN_COOKIE_KEY };
